import React, {
  useContext, useState, useEffect, useCallback,
} from 'react'
import { RMA as CPRMA, RMADetails as CPRMADetails } from '@usap/widgets'
import { useResponsiveWrapperContext } from '@usap/uicomponents'
import captchaConfig from '../../../config/captcha-config'
import localConfig from '../../../config/local-config'
import OpenChat from '../Kustomer/Events'
import GTM from '../../helpers/GTM'
import { getSingleState } from '../../helpers/localForage'
import { LocalContext } from '../../helpers/useLocalContext'
import { getProxyOrder } from '../../helpers/getProxyOrderDetails'
import ReturnReasonUtils from '../../helpers/returnRequestUtils'
import transformComponents from '../../helpers/transformComponents'
import useGetParamsQuery from '../../../hooks/useGetParsedQuery'
import { openSparkChatModal } from '../../helpers'
import { useSparkChatEnabled } from '../../hooks'

const { siteKey } = captchaConfig

const RMA = props => {
  const {
    isBot,
    history,
    apiDetails,
  } = props

  const {
    credit_status: creditStatus = {},
    return_request_status: returnRequestStatus = {},
  } = apiDetails

  const { isDesktop } = useResponsiveWrapperContext()
  const { localContext } = useContext(LocalContext)
  const { Link } = localContext

  const [loading, setLoading] = useState(false)
  const [orderDetails, setOrderDetails] = useState(null)
  const [returnQuantity, setReturnQuantity] = useState(null)
  const [appSteps, setAppSteps] = useState([])
  const [imgSteps, setImgSteps] = useState({})
  const [docSteps, setDocSteps] = useState({})
  const [customerOrder, setCustomerOrder] = useState({})
  const [fileUpload, setFileUpload] = useState({})
  const [formFile, setFormFile] = useState({})
  const [formFileMain, setFormFileMain] = useState([])
  const [tempStep, setTempStep] = useState([])
  const [reqElem, setReqElem] = useState([])
  const [historyRef, setHistoryRef] = useState('')
  const [tokenCustomerId, setTokenCustomerId] = useState(0)
  const [showTabs, setShowTabs] = useState(false)
  const [showReturnDetails, setReturnDetailsFlag] = useState(false)
  const isSparkChatEnabled = useSparkChatEnabled()

  const { returnRequests = {} } = localConfig
  const { mechanicDiagnosis = [] } = returnRequests

  const searchParsed = useGetParamsQuery()
  const returnType = searchParsed.returnType
    ? searchParsed.returnType
    : ''
  const returnTypeParam = returnType ? `returnType=${returnType}` : ''

  useEffect(() => {
    if (customerOrder.length) {
      const orderData = customerOrder.order
      const orderItemData = orderData.items

      orderItemData.forEach(item => {
        const orderItemQty = item.quantity
        orderItemQty.return = returnQuantity
      })
    }
  }, [customerOrder, returnQuantity])

  useEffect(() => {
    getSingleState('token').then(([, token]) => {
      setTokenCustomerId(token.customer_id)
      const reqUrl = window.location.href
      if (reqUrl.includes('myaccount/rma') &&
        !searchParsed.orderId &&
        Boolean(parseInt(token.customer_id, 10))) {
        history.push(`/myaccount/orderhistory?${returnTypeParam}`)
      }
    })
  }, [customerOrder.customer, history, searchParsed.orderId])

  useEffect(() => {
    if (searchParsed) {
      const {
        emailAdd, orderId, sku, fromChat = false,
      } = searchParsed

      if (fromChat) {
        setReturnDetailsFlag(false)
      } else if (orderId) {
        setReturnDetailsFlag(true)
        setLoading(true)
        getProxyOrder({ orderId, emailAdd })
          .then(res => {
            setLoading(false)
            const transformSetKit = transformComponents(res)
            const sortEligible = ReturnReasonUtils.transformReturnRequests(transformSetKit)

            setOrderDetails(sortEligible)

            if (emailAdd) {
              setHistoryRef(`trackorder?${returnTypeParam}`)
            } else if (sku) {
              setHistoryRef(`orderdetails?orderId=${orderId}&${returnTypeParam}`)
            } else {
              setHistoryRef(`orderhistory?${returnTypeParam}`)
            }
            return res
          })
          .catch(error => {
            setLoading(false)
            history.push(
              `/myaccount/login?referrer=myaccount/rma?orderId=${orderId}&${returnTypeParam}`,
            )
            throw error
          })
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit = async ({ emailAdd, orderId }) => {
    try {
      setLoading(true)
      const orderInfo = await getProxyOrder({ emailAdd, orderId })
      const transformSetKit = transformComponents(orderInfo)
      const sortEligible = ReturnReasonUtils.transformReturnRequests(transformSetKit)

      setOrderDetails(sortEligible)
      setLoading(false)

      return sortEligible
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('[ssr2]: ', error)
      let errorMessage = 'Site is currently under maintenance. Please try again later'
      if (error.message.includes('400')) {
        errorMessage = 'Email or Order Number does not exists.'
      } else if (error.message.includes('404')) {
        errorMessage = 'Data not Found.'
      }
      setLoading(false)
      return {
        error: true,
        message: errorMessage,
      }
    }
  }

  const onCancelReturn = () => {
    setShowTabs(false)
    setAppSteps([])
    setImgSteps({})
    setOrderDetails(null)
    setReqElem([])
    setAppSteps([])
    setImgSteps([])
    setDocSteps([])
    setTempStep([])
    setCustomerOrder({})

    if (historyRef) {
      history.push(`/myaccount/${historyRef}`)
    } else {
      history.push(`/myaccount/rma?${returnTypeParam}`)
    }
  }

  const openChatHandler = () => {
    if(isSparkChatEnabled) {
      openSparkChatModal();
    } else {
      OpenChat();
    }
  }

  if (showReturnDetails) {
    return (
      <CPRMADetails
        isDesktop={isDesktop}
        Link={Link}
        isBot={isBot}
        loading={loading}
        setLoading={setLoading}
        onCancelReturn={onCancelReturn}
        orderDetails={orderDetails}
        handleReason={ReturnReasonUtils}
        GTM={GTM}
        appSteps={appSteps}
        setAppSteps={setAppSteps}
        imgSteps={imgSteps}
        setImgSteps={setImgSteps}
        docSteps={docSteps}
        setDocSteps={setDocSteps}
        customerOrder={customerOrder}
        setCustomerOrder={setCustomerOrder}
        fileUpload={fileUpload}
        setFileUpload={setFileUpload}
        formFile={formFile}
        setFormFile={setFormFile}
        partSku={searchParsed.sku}
        tempStep={tempStep}
        setTempStep={setTempStep}
        reqElem={reqElem}
        setReqElem={setReqElem}
        returnQuantity={returnQuantity}
        setReturnQuantity={setReturnQuantity}
        showTabs={showTabs}
        setShowTabs={setShowTabs}
        formFileMain={formFileMain}
        setFormFileMain={setFormFileMain}
        tokenCustomerId={tokenCustomerId}
        returnReasonUtils={ReturnReasonUtils}
        mechanicDiagnosis={mechanicDiagnosis}
        creditStatus={creditStatus}
        returnRequestStatus={returnRequestStatus}
        OpenChatHandler={openChatHandler}
      />
    )
  }

  return (
    <CPRMA
      isDesktop={isDesktop}
      Link={Link}
      isBot={isBot}
      loading={loading}
      setLoading={setLoading}
      onSubmit={onSubmit}
      onCancelReturn={onCancelReturn}
      orderDetails={orderDetails}
      handleReason={ReturnReasonUtils}
      appSteps={appSteps}
      setAppSteps={setAppSteps}
      GTM={GTM}
      imgSteps={imgSteps}
      setImgSteps={setImgSteps}
      docSteps={docSteps}
      setDocSteps={setDocSteps}
      customerOrder={customerOrder}
      setCustomerOrder={setCustomerOrder}
      fileUpload={fileUpload}
      setFileUpload={setFileUpload}
      formFile={formFile}
      setFormFile={setFormFile}
      tempStep={tempStep}
      setTempStep={setTempStep}
      reqElem={reqElem}
      setReqElem={setReqElem}
      returnQuantity={returnQuantity}
      setReturnQuantity={setReturnQuantity}
      mechanicDiagnosis={mechanicDiagnosis}
      tokenCustomerId={tokenCustomerId}
      showTabs={showTabs}
      setShowTabs={setShowTabs}
      formFileMain={formFileMain}
      setFormFileMain={setFormFileMain}
      creditStatus={creditStatus}
      returnRequestStatus={returnRequestStatus}
      returnReasonUtils={ReturnReasonUtils}
      siteKey={siteKey}
      OpenChatHandler={openChatHandler}
    />
  )
}

export default RMA
